import {makeAutoObservable} from "mobx"
import $ from "jquery";
import {
    calc_leeftijd,
    capitalize_first_letter,
    clamped_reduce_by,
    contains_double_letters,
    get_initials,
    get_provincie_hoofdstad,
    get_provincies,
    not_achternaam,
    not_man_voornaam,
    not_plaats,
    not_street,
    not_vrouw_voornaam,
    question_order,
    shuffleArray,
    to_maand_naam,
    was_birthday,
    zodiac
} from "../data/questions";
import {fakeProfiles, Profile,} from "../data/profiles";
import {mouseState, randomize_challenge} from "./mouseState"

import {create} from "random-seed";

export const ApplicationState = {
    APP_LOADING: -1,
    APP_INFORMED_CONSENT: 0,
    APP_PHASE_1: 7,
    APP_INSTRUCTION_PROFILE: 1, /* with identity info */
    APP_INSTRUCTION_PROFILE_RETRY: 6, /* with identity info */
    APP_PRE_PHASE: 8,
    APP_MOUSE_CALIBRATION: 3,
    APP_TRAINING: 2,
    APP_CHAT: 4,
    APP_INVALID_LINK: 5, APP_PHASE_1_PRE: 9, APP_PHASE_2_PRE: 10, APP_FINISH: 11
}

let questions = []

class ExperimentState {

    // if domain equals experiment.haastnooit.com set app to loading, ese set it to app_chat

    application_state = ApplicationState.APP_LOADING
    // application_state = ApplicationState.APP_CHAT
    questionIsShown = false;
    questionBlockActive = false;

    setApplicationState(newState) {
        if (newState === ApplicationState.APP_MOUSE_CALIBRATION && this.experimentParams.admin) {
            newState = ApplicationState.APP_CHAT
        }
        this.application_state = newState;
    }


    messages = [
        // {user: "p1", message: "Hello, wut one"},
        // {user: "p2", message: "Hello message 2"},
        // {user: "p1", message: "Hello message 2"},
    ]

    emptyMessages() {
        this.messages = []
    }

    events = []
    users_typing = {}
    user = null
    room_id = null
    channel = null
    curMessage = null

    fields = Profile.fields
    realProfile = Profile.defaultProfile()
    useProfile = Profile.defaultProfile()
    dummyProfile = Profile.defaultProfile()


    experimentParams = {
        lie: true,
        admin: true,
        profile: 1,
        shuffle_seed: "1337",
    }
    challengeEnabled = false

    resetChallengeState() {
        this.challengeState = null;
        this.challengeEnabled = false;
    }

    setChallengeState(state) {
        this.challengeState = state
    }

    enableChallengeState() {
        this.challengeEnabled = true;
        mouseState.addTransform(this.challengeState)
    }

    loaded = false

    setRealProfile(realProfile) {
        this.realProfile = realProfile
    }

    setUseProfile(useProfile) {
        this.useProfile = useProfile
    }

    constructor() {
        makeAutoObservable(this);
    }

    setQuestions(questions) {
        this.questions = questions
    }

    newMessage(message) {
        if (!message.user === 'Interviewer' && message.run_id === undefined) {
            // console.log("Received message", message, "setting questionstarted to false", this.questionsStarted)
            this.questionsStarted = false;

            let textarea = document.getElementById('textarea')
            if (textarea && isInside(textarea, mouseState.mouse_x - window.scrollX, mouseState.mouse_y - window.scrollY)) {

                if ($(textarea).prop('disabled')) {
                    $(textarea).prop('disabled', false)
                }
                $(textarea).focus()

            }
        }
        this.messages.push(message)
    }

    setUserTyping(user, isTyping) {
        this.users_typing[user] = isTyping;
    }

    setChannel(channel) {
        this.channel = channel;
    }

    setRoomId(room_id) {
        this.room_id = room_id;
    }

    setUser(user) {
        this.user = user
    }

    setExperimentParams(params) {
        this.loaded = true
        this.experimentParams = params
        this.setUseProfile(fakeProfiles[this.experimentParams.profile])
        if (this.experimentParams.admin) {
            this.application_state = ApplicationState.APP_CHAT
        }
        this.questions = this.renderQuestionsShuffleWithSeed(this.experimentParams.shuffle_seed)
        this.thirdPartyQuestions = this.renderSimpleShortQuestionsThirdPerson(this.experimentParams.shuffle_seed)
    }

    addEvent(event) {
        if (ApplicationState.APP_CHAT || ApplicationState.APP_MOUSE_CALIBRATION) {
            // Only record when person is in chat
            this.events.push(event)
        }
    }

    deleteEvents() {
        this.events = []
    }

    renderSimpleShortQuestions = (profile, rand) => {
        let {
            firstname,
            lastname,
            place_of_birth,
            gender,
            birth_year,
            birth_month,
            birth_day,
            place_of_residence,
            street_of_residence,
            is_student,
            has_partner
        } = profile

        birth_year = Number(birth_year)
        birth_month = Number(birth_month)
        birth_day = Number(birth_day)
        return [
            // Simple, short, true
            [0, `Is jouw voornaam ${capitalize_first_letter(firstname)}?`, `Is jouw voornaam ${(gender) ? not_man_voornaam(firstname, rand) : not_vrouw_voornaam(firstname, rand)}?`, "short"],
            [1, `Is jouw achternaam ${capitalize_first_letter(lastname)}?`, `Is jouw achternaam ${not_achternaam(lastname, rand)}?`, "short"],
            [2, `Is jouw geboortejaar ${birth_year}?`, `Ben jij in ${birth_year - 2} geboren?`, "short"],
            [3, `Ben jij in ${to_maand_naam(birth_month)} geboren?`, `Ben jij in ${to_maand_naam(clamped_reduce_by(birth_month, 1, 12, 1))} geboren?`, "short"],
            [4, `Ben jij op dag ${birth_day} van de maand geboren?`, `Ben jij op dag ${clamped_reduce_by(birth_day, 1, 31, 7)} van de maand geboren?`, "short"],
            [5, `Ben jij geboren in ${capitalize_first_letter(place_of_birth)}?`, `Ben jij in ${capitalize_first_letter(not_plaats(place_of_birth, rand))} geboren?`, "short"],
            [6, `Woon jij in ${capitalize_first_letter(place_of_residence)}?`, `Woon jij in ${capitalize_first_letter(not_plaats(place_of_residence, rand))}?`, "short"],
            [7, `Woon jij op de ${capitalize_first_letter(street_of_residence)}?`, `Woon jij op de ${capitalize_first_letter(not_street(street_of_residence, rand))}?`, "short"],
            [8, `${(has_partner) ? "Heb jij een relatie" : "Ben jij single"}?`, `${(!has_partner) ? "Heb jij een relatie" : "Ben jij single"}?`, "short"],
            [9, `Ben jij ${(is_student) ? "een student?" : "al klaar met studeren?"}`, `Ben jij ${(!is_student) ? "een student?" : "al klaar met studeren?"}`, "short"],
        ]
    }
    renderDerivedQuestions = (profile, rand) => {
        let {
            firstname,
            lastname,
            place_of_birth,
            gender,
            birth_year,
            birth_month,
            birth_day,
            place_of_residence,
            street_of_residence,
            is_student,
            has_partner
        } = profile
        birth_year = Number(birth_year)
        birth_month = Number(birth_month)
        birth_day = Number(birth_day)
        return [
            // Simple, short, true
            [0, `Ben jij ${calc_leeftijd(birth_year, birth_month, birth_day)} jaar oud?`, `Ben jij ${calc_leeftijd(birth_year - 2, birth_month, birth_day)} jaar oud?`, 'short', true],
            [1, `Is jouw sterrenbeeld ${zodiac(birth_day, birth_month)}?`, `Is jouw sterrenbeeld ${zodiac(birth_day, clamped_reduce_by(birth_month, 1, 12, 3))}?`, 'short', true],
            [2, `Ben jij geboren in ${capitalize_first_letter(get_provincies(place_of_birth))}?`, `Ben jij geboren in ${capitalize_first_letter(get_provincies(not_plaats(place_of_birth, rand)))}?`, 'short', true],
            [3, `Woon jij in ${capitalize_first_letter(get_provincies(place_of_residence))}?`, `Woon jij in ${capitalize_first_letter(get_provincies(not_plaats(place_of_residence, rand)))}?`, 'short', true],
            // hello
            // [4, `Is ${get_provincie_hoofdstad(get_provincies(place_of_birth))} de hoofdstad van de provincie waar jij geboren bent?`, `Is ${get_provincie_hoofdstad(get_provincies(not_plaats(get_provincie_hoofdstad(get_provincies(place_of_birth)), rand)))} de hoofdstad van de provincie waar jij geboren bent?`, 'short', true],
            //wut
            [4, `Is ${capitalize_first_letter(get_provincie_hoofdstad(get_provincies(place_of_residence)))} de hoofdstad van de provincie waar jij woont?`, `Is ${capitalize_first_letter(get_provincie_hoofdstad(get_provincies(not_plaats(get_provincie_hoofdstad(get_provincies(place_of_residence)), rand))))} de hoofdstad van de provincie waar jij woont?`, 'short', true],
            [5, `Bevat jouw VOORNAAM ${(contains_double_letters(firstname) ? "dubbele letters" : "alleen enkele letters")}?`, `Bevat jouw VOORNAAM ${(!contains_double_letters(firstname) ? "dubbele letters" : "alleen enkele letters")}?`, 'short', true],
            [6, `Zijn de initialen van jouw naam ${get_initials(firstname, lastname)}?`, `Zijn de initialen van jouw naam ${get_initials(not_man_voornaam(firstname, rand), not_achternaam(lastname, rand))}?`, 'short', true],
            [7, `${was_birthday(birth_month, birth_day) ? "Is jouw verjaardag al geweest" : "Moet jouw verjaardag nog komen"} dit jaar?`, `${!was_birthday(birth_month, birth_day) ? "Is jouw verjaardag al geweest" : "Moet jouw verjaardag nog komen"} dit jaar?`, 'short', true],
            [8, `Bevat jouw ACHTERNAAM ${(contains_double_letters(lastname) ? "dubbele letters" : "alleen enkele letters")}?`, `Bevat jouw ACHTERNAAM ${(!contains_double_letters(lastname) ? "dubbele letters" : "alleen enkele letters")}?`, 'short', true],
            [9, `Was jij op deze datum vorig jaar ${calc_leeftijd(birth_year + 1, birth_month, birth_day)} jaar oud?`, `Was jij op deze datum vorig jaar ${calc_leeftijd(birth_year + 5, birth_month, birth_day)} jaar oud?`, 'short', true],
            // Future: telefoon are code
            // Future: postal code
            // // false
            // // [11, `Ben jij ${calc_leeftijd(birth_year - 2, birth_month, birth_day)} jaar oud?`, 'short', false],
            // //test3
            // [12, `Is jouw sterrenbeeld ${zodiac(birth_day, clamped_reduce_by(birth_month, 1, 12, 3))}?`, 'short', false],
            // [13, `Ben jij geboren in ${get_provincies(not_plaats(place_of_birth))}?`, 'short', false],
            // [14, `Woon jij in ${get_provincies(not_plaats(place_of_residence))}`, 'short', false],
            //
            //
            // [15, `Bevat jouw voornaam ${(!!contains_double_letters(firstname) ? "" : "geen ")} dubbele letters?`, 'short', false],
            // [16, `Zijn de initialen van jouw naam ${get_initials(not_man_voornaam(firstname), not_achternaam(lastname))}?`, 'short', false],
            // [17, `Is jouw verjaardag ${was_birthday(birth_month, birth_day) ? "al" : "nog niet"} geweest dit jaar?`, 'short', false],
            // [18, `Bevat jouw achternaam ${(contains_double_letters(lastname) ? "" : "geen ")} dubbele letters?`, 'short', false],
            // [19, `Was jij op deze datum vorig jaar ${calc_leeftijd(birth_year + 5, birth_month, birth_day)} jaar oud?`, 'short', false],

            // Simple, short, true
            // [11,`Woon jij ${(dichtbij_zee(get_provincies(place_of_residence))) ? "" : "niet "}in de buurt van de zee?`, 'short', true],
            // [12,`Woon jij ${(get_provincies(place_of_residence) === get_provincies(place_of_birth)) ? "" : "niet "}in dezelfde provincie als waar je geboren bent?`, 'short', true],
            //
            // // false
            // [13,`Is ${get_provincie_hoofdstad(get_provincies(not_plaats(get_provincie_hoofdstad(get_provincies(place_of_birth)))))} de hoofdstad van de provincie waar jij geboren bent?`, 'short', false],
            // // test1
            // [14,`Is ${get_provincie_hoofdstad(get_provincies(not_plaats(get_provincie_hoofdstad(get_provincies(place_of_residence)))))} de hoofdstad van de provincie waar jij woont?`, 'short', false],

        ]

    }

    renderControlQuestions(rand) {
        let daglijst = ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
        let maandlijst = ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "october", "november", "december"]
        let now = new Date()
        return [
            // Simple, short, true
            [0, `Woon jij in Nederland?`, `Woon jij in Peru?`, 'short', true],
            [1, `Ben jij geboren in Nederland?`, `Ben jij geboren in China?`, 'short', true],
            [2, `Heb jij 5-10 minuten geleden een online tentamen gemaakt?`, `Heb jij 5-10 minuten geleden boodschappen gedaan?`, 'short', true],
            [3, `Typ jij jouw antwoorden op een toetsenbord?`, `Typ jij jouw antwoorden met een typmachine?`, 'short', true],
            [4, `Gebruik je op dit moment een browser?`, `Gebruik je op dit moment een smartphone?`, 'short', true],
            [5, `Is het vandaag ${daglijst[now.getDay()]}?`, `Is het vandaag ${daglijst[(now.getDay() + 3) % 7]}?`, "short", true],
            [6, `Is het nu de maand ${maandlijst[now.getMonth()]}?`, `Is het nu de maand ${maandlijst[(now.getMonth() + 6) % 12]}?`, "short", true],
            [7, `Is Dick Schoof de huidige minister-president van Nederland?`, `Is Mark Rutte de huidige minister-president van Nederland?`, "short", true],
            [8, `Zit je nu achter een computer/laptop?`, `Zit je nu TV te kijken?`, "short", true],
            [9, `Antwoord Ja op deze vraag`, `Antwoord Nee op deze vraag`, "short", true],

        ]
    }

    renderTrainingQuestionsShuffleWithSeed(seed) {

        let rand = create(seed)
        let simpleQuestions = this.renderSimpleShortQuestions(this.useProfile, rand)
        let allQuestions = []
        allQuestions.push(...simpleQuestions.map(([qid, msg_pos, msg_neg, _], idx) => {
            return [[qid, idx, msg_pos, "simple", true], [qid, idx, msg_neg, "simple", false]]
        }).flatMap(ele => ele))
        allQuestions = shuffleArray(allQuestions, rand)
        return allQuestions
    }

    renderIqQuestions(rand) {
        function gen(inner_fn, a, b, c) {
            function outer_fn(x) {
                if (x === 0) {
                    return a
                } else {
                    return outer_fn(x - 1) + inner_fn(x, b, c)
                }
            }

            return outer_fn

        }

        const cartesian = (...all) => {
            const loop = (t, a, ...more) =>
                a === undefined
                    ? [t]
                    : a.flatMap(x => loop([...t, x], ...more))
            return loop([], ...all)
        }

        let a5 = Array.from(Array(7).keys()).map(e => e - 2)


        let sequentialFn = [
            [5, (x, b, c) => {
                return b * Math.pow(c, x - 1)
            }, "b*c^n"],
            [5, (x, b, c) => {
                return b * x + c
            }, "b*n + c"],
            [5, (x, b, c) => {
                return Math.pow(-1, x) * b * x
            }, "(-1)^n*b*n"],
            [5, (x, b, c) => {
                return Math.pow(-1, x) * b * x * x
            }, "(-1)^n*b*n^2"],
            // [4,(x,b,c) => {return Math.pow(-1,x)*b*x + c},"(-1)^n*b*n + c"],
            // [4,(x,b,c) => {return b * x * Factorial(x)},"b*n*(n!)"],
            [5, (x, b, c) => {
                return Math.pow(x, b)
            }, "x^b + c"],
        ]

        function mod(x, y) {
            return ((x % y) + y) % y
        }

        // take parameters a,b,c (all combo's).
        // Take functions as defined in blaat, combine with all th eparameters abc
        // for numbers 1,5, produce the sequence.
        // for numbers 5+1 - produce the answer
        // from surrounding blaat shit
        let amazingFns = cartesian(a5, a5, a5, sequentialFn).filter(([a, b, c, _1], idx) => {
            return (a + b + c < 7) && (a > 2) && (b !== 0) && (c !== 0)
        }).map(([a, b, c, [o, fn, k]], idx) => [o, gen(fn, a, b, c), `${k}_${a}_${b}_${c}`])
            .filter(
                ([c, b, k], idx) => Array.from(Array(c).keys()).map(e => e + 1).map(b).every(e => Number.isInteger(e))
            )

        return amazingFns.map(([c, b, k], idx) => {
            if (Array.from(Array(c).keys()).map(e => e + 1).map(b).every(e => Number.isInteger(e))) {

                return {
                    header: "Wat is het volgende getal in deze rij?",
                    body: `${Array.from(Array(c).keys()).map(e => e + 1).map(b).join(", ")}, ___?`,
                    key: k,
                    correct: b(c + 1),
                    answers: shuffleArray([
                        amazingFns[mod(idx - 2, amazingFns.length)][1](c + 1),
                        amazingFns[mod(idx - 1, amazingFns.length)][1](c + 1),
                        b(c + 1),
                        amazingFns[mod(idx + 1, amazingFns.length)][1](c + 1)
                    ], rand),
                    forceCorrect: false

                }
            } else {
                return undefined
            }
            //return `${k} - ${Array.from(Array(c).keys()).map(e => e+1).map(b).join(", ")}, ___ (${b(c+1)})`
        }).filter(e => e)

    }


    transformRawQuestions(typestr, crOrder, offset) {
        let noCr = {
            challenge: false
        }

        let crmag = .7

        let yesCr = {
            challenge: true,
            send_button_scale: crmag,
            compress_x: crmag,
            compress_y: crmag
        }
        let crKind = [noCr, yesCr]
        let out = ([qid, msg_pos, msg_neg, _], idx) => {
            return [[qid, offset + (idx * 2), msg_pos, typestr, true, crKind[crOrder[idx] ? 1 : 0]], [qid, offset + (2 * idx) + 1, msg_neg, typestr, false, crKind[crOrder[idx] ? 0 : 1]]]
        }
        return out
    }

    renderQuestionsShuffleWithSeed = (seed) => {
        // seed = "2292e6216436e1e9d08892a5f84418a7ab9dad8d4601c02761fa9ef7c2090b8"
        let rand = create(seed)


        let crOrder = [false, false, false, false, false, true, true, true, true, true]


        let simpleQuestions = shuffleArray(this.renderSimpleShortQuestions(this.useProfile, rand), rand)
        let complexQuestions = shuffleArray(this.renderDerivedQuestions(this.useProfile, rand), rand)
        let controlQuestions = shuffleArray(this.renderControlQuestions(rand), rand)

        let simpleQuestionsForFalse = shuffleArray(simpleQuestions, rand)
        let complexQuestionsForFalse = shuffleArray(complexQuestions, rand)
        let controlQuestionsForFalse = shuffleArray(controlQuestions, rand)

        // console.log(simpleQuestions)
        // console.log(simpleQuestionsForFalse)
        let noCr = [[], 1.3, []]


        let crmag = .7

        let yesCr = [{
            challenge: true,
            send_button_scale: crmag,
            compress_x: crmag,
            compress_y: crmag,
            lanes: [],
        }]


        // console.log(allQuestions.map(([_1, qid], _idx) => qid))
        return question_order.map(
            (q, idx) => {
                let {challenge, answer, qtype, type_id} = q
                let offset = 2424
                let useq = []
                switch (qtype) {
                    case "simple":
                        useq = (answer) ? simpleQuestions : simpleQuestionsForFalse
                        offset = 0
                        break;
                    case "hard":
                        useq = (answer) ? complexQuestions : complexQuestionsForFalse
                        offset = 20
                        break;
                    case "control":
                        useq = (answer) ? controlQuestions : controlQuestionsForFalse
                        offset = 40
                        break;
                    default:
                        throw new DOMException()
                }
                let [qid, msg_pos, msg_neg, _] = useq[type_id]

                let text = (answer) ? msg_pos : msg_neg
                let cr = noCr
                if (challenge) {
                    cr = randomize_challenge(rand, true, false)
                }
                return [qid, offset + (qid * 2) + ((answer) ? 0 : 1), text, qtype, answer, cr]

            })
    }


    renderSimpleShortQuestionsThirdPerson = (shuffle_seed) => {
        let rand = create(shuffle_seed)
        let {
            firstname,
            lastname,
            place_of_birth,
            gender,
            birth_year,
            birth_month,
            birth_day,
            place_of_residence,
            street_of_residence,
            is_student,
            has_partner
        } = this.useProfile

        birth_year = Number(birth_year)
        birth_month = Number(birth_month)
        birth_day = Number(birth_day)
        let crOrder = [false, false, false, false, false, true, true, true, true, true]
        return shuffleArray([
            // Simple, short, true
            [1, `Is ${lastname} de achternaam van ${firstname}?`, `Is ${not_achternaam(lastname, rand)} de achternaam van ${firstname}?`, "short"],
            [2, `Is ${birth_year} het geboortejaar van ${firstname}?`, `Is ${birth_year - 2} het geboortejaar van ${firstname}?`, "short"],
            [3, `Is ${firstname} geboren in ${to_maand_naam(birth_month)}?`, `Is ${firstname} geboren in ${to_maand_naam(clamped_reduce_by(birth_month, 1, 12, 1))}?`, "short"],
            [4, `Is ${firstname} geboren op dag ${birth_day} van de maand?`, `Is ${firstname} geboren op dag ${clamped_reduce_by(birth_day, 1, 31, 7)} van de maand?`, "short"],
            [5, `Is ${firstname} geboren in ${place_of_birth}?`, `Is ${firstname} geboren in ${not_plaats(place_of_birth, rand)}?`, "short"],
            [6, `Woont ${firstname} in ${place_of_residence}?`, `Woont ${firstname} in ${not_plaats(place_of_residence, rand)}?`, "short"],
            [7, `Woont ${firstname} op de ${street_of_residence}?`, `Woont ${firstname} op de ${not_street(street_of_residence, rand)}?`, "short"],
            [8, `${(has_partner) ? `Heeft ${firstname} een relatie?` : `Is ${firstname} single?`}`, `${(!has_partner) ? `Heeft ${firstname} een relatie?` : `Is ${firstname} single?`}`, "short"],
            [9, `Is ${firstname} ${(is_student) ? "een student?" : "al klaar met studeren?"}`, `Is ${firstname} ${(!is_student) ? "een student?" : "al klaar met studeren?"}`, "short"],
        ].map(this.transformRawQuestions("third", crOrder, 60)).flatMap(ele => ele), rand)
    }


    runId = 0

    incrRunId() {
        this.runId += 1
    }

    questions = this.renderQuestionsShuffleWithSeed(this.experimentParams.shuffle_seed)
    thirdPartyQuestions = this.renderSimpleShortQuestionsThirdPerson(this.experimentParams.shuffle_seed)

    setThirdPartyQuestions(questions) {
        this.thirdPartyQuestions = questions
    }

    sendingQuestions = 0

    decrSendingQuestions() {
        this.sendingQuestions -= 1
    }

    startSendingQuestions(amount) {
        this.sendingQuestions = amount
    }

    questionStart = null

    setQuestionStart(now) {
        console.log("Starting question", this.questionsStarted, this.questionStart, now)
        this.questionsStarted = true;
        this.questionStart = now
        this.questionIsShown = !!now;

        let textarea = document.getElementById('textarea')
        if (textarea && isInside(textarea, mouseState.mouse_x - window.scrollX, mouseState.mouse_y - window.scrollY)) {

            if ($(textarea).prop('disabled')) {
                $(textarea).prop('disabled', false)
            }
            $(textarea).focus()

        }
    }

    questionExpired = false

    setQuestionExpired(expired) {
        this.questionExpired = expired
    }

    questionsStarted = false
    questionsFinished = 0
    questionsExpired = 0

    incrQuestionsExpired() {
        this.questionsExpired += 1
    }

    incrQuestionsFinished() {
        this.questionsFinished += 1
    }

    N_BLOCKS = 5

    myEmail = () => {
        return String.fromCharCode(101, 46, 104, 97, 97, 115, 110, 111, 111, 116, 64, 117, 116, 119, 101, 110, 116, 101, 46, 110, 108)
    }

    fake_mouse_visible = false

    setFakeMouseVisibility(visibility) {
        this.fake_mouse_visible = visibility;
    }

    pressedSendOnce = true;

    setPressedSend(pressedSend) {

        this.pressedSendOnce = pressedSend;
    }
}

function isInside(element, x, y) {
    const rect = element.getBoundingClientRect();
    return (
        x >= rect.left &&
        x <= rect.right &&
        y >= rect.top &&
        y <= rect.bottom
    );
}


const experimentState = new ExperimentState()
window.renderQuestions = experimentState.renderQuestionsShuffleWithSeed
window.experimentState = experimentState
export default experimentState;